import { forReader } from './reader';

import exUploadDemo from '../upload/demo';

// ----------------------------------------------------------------------------

async function demo(config: Record<string, any> = {}): Promise<ArrayBuffer[]> {
    //
    const files = await exUploadDemo(config.upload);

    //
    const arrayBuffers = await forReader(files, config.reader);

    //
    return arrayBuffers;
}

// ----------------------------------------------------------------------------

export { demo };
